import React, { FC, useCallback, useState } from 'react'
import styled from '@emotion/styled'

import { useAuth } from 'core/auth'
import { useNftEdit } from 'core/nft/api/useNftEdit'
import { NftDetail } from 'core/nft/models'
import { useShowMessage, useApiError } from 'shared/hooks'

import { Spin, Input } from 'antd'

export const NftOnBlockChain: FC<{ detail: NftDetail }> = ({ detail }) => {
    const {
        methods: { error, success }
    } = useShowMessage()
    const {
        methods: { handleError }
    } = useApiError('NftEdit', error as any)
    const { account } = useAuth()
    const {
        loading,
        methods: { edit }
    } = useNftEdit()

    const [name, setName] = useState(detail.name)
    const [description, setDescription] = useState(detail.description)
    const [tokenAddress, setTokenAddress] = useState(detail.token_address)
    const [tokenId, setTokenId] = useState(detail.token_id)
    const [externalUrl, setExternalUrl] = useState(detail.external_url)
    const [tags, setTags] = useState(detail.tags.join(','))

    const handleSubmit = useCallback(() => {
        if (!account) return
        edit({ name, owner: account, description, tags })
            .then(() => {
                setName('')
                setDescription('')
                setTags('')
                success('Edit successfully')
            })
            .catch(_err => {
                handleError('Edit failed')
            })
    }, [account, description, edit, handleError, name, success, tags])

    return (
        <Spin spinning={loading}>
            <Container>
                <div className="item">
                    <div className="label">
                        <div>NFT Name</div>
                    </div>
                    <Input
                        style={{ width: '100%', height: '40px' }}
                        disabled={!!name}
                        value={name}
                        onChange={e => setName(e.target.value)}
                    />
                </div>
                <div className="item">
                    <div className="label">
                        <div>Description</div>
                    </div>
                    <Input.TextArea
                        style={{ width: '100%', height: '80px' }}
                        disabled={!!description}
                        value={description}
                        onChange={e => setDescription(e.target.value)}
                    />
                </div>
                <div className="item">
                    <div className="label">
                        <div>Owner Address</div>
                    </div>
                    <Input style={{ width: '100%', height: '40px' }} disabled value={account || ''} />
                </div>
                <div className="item">
                    <div className="label">
                        <div>Token Address</div>
                    </div>
                    <Input
                        style={{ width: '100%', height: '40px' }}
                        disabled={!!tokenAddress}
                        value={tokenAddress}
                        onChange={e => setTokenAddress(e.target.value)}
                    />
                </div>
                <div className="item">
                    <div className="label">
                        <div>Token ID</div>
                    </div>
                    <Input
                        style={{ width: '100%', height: '40px' }}
                        disabled={!!tokenId}
                        value={tokenId}
                        onChange={e => setTokenId(e.target.value)}
                    />
                </div>
                <div className="item">
                    <div className="label">
                        <div>External URL</div>
                    </div>
                    <Input
                        style={{ width: '100%', height: '40px' }}
                        disabled={!!externalUrl}
                        value={externalUrl}
                        onChange={e => setExternalUrl(e.target.value)}
                    />
                </div>
                <div className="item">
                    <div className="label">
                        <div>Tag</div>
                    </div>
                    <Input
                        style={{ width: '100%', height: '40px' }}
                        value={tags}
                        onChange={e => setTags(e.target.value)}
                        placeholder={'separate tag with comma'}
                    />
                </div>
                <div className="btn" onClick={handleSubmit}>
                    Submit
                </div>
            </Container>
        </Spin>
    )
}

const Container = styled.div`
    .item {
        margin-bottom: 30px;
        .label {
            margin-bottom: 10px;
            font-family: HelveticaNeue-Medium;
            font-size: 18px;
            color: #000000;
            line-height: 26px;
        }
        .tip {
            font-family: Roboto-Regular;
            font-size: 12px;
            color: #000000;
        }
    }
    .ant-input {
        font-family: Roboto-Regular;
        font-size: 18px;
        &::placeholder {
            font-family: Roboto-Regular;
            font-size: 16px;
            color: #c2c2c2;
        }
    }
    .upload-style {
        .ant-upload-list-picture-card-container {
            width: 320px;
            height: 180px;
        }
        .ant-upload.ant-upload-select-picture-card {
            background-color: #ffffff;
        }
        .ant-upload {
            width: 320px;
            height: 180px;
        }
    }
    .btn {
        width: 100%;
        height: 50px;
        font-family: Roboto-Medium;
        font-size: 25.33px;
        color: #ffffff;
        letter-spacing: 0;
        text-align: center;
        line-height: 50px;
        background: #000000;
        border-radius: 35.18px;
        cursor: pointer;
    }
    @media (max-width: 768px) {
        padding: 0 20px 40px 20px;
        width: 100%;
    }
`
